module.exports = __webpack_public_path__ + "img/bullet.c3bb4fe0.svg";